import { Physician } from '../types/patientTrackerStore';
import { PatientDataWithMatchesDto, PatientTrackingDetailResponseDto } from '../types/timePatientTracking';
import axios from '../axios';
import { TRIALS_NEST_API_ROOT } from '../constants';

export const patientsNewApi = {
  getPatientTrackingData: async (
    patientLinkageId: string,
    institutionId: string,
    options?: { carePathwayId?: string },
  ): Promise<{
    timePatientTracking: PatientDataWithMatchesDto;
    nextPatientTracking: PatientTrackingDetailResponseDto;
  }> => {
    const carePathwayId = options?.carePathwayId?.trim();
    return axios
      .get(`${TRIALS_NEST_API_ROOT}/v1/patients/${patientLinkageId}/institutions/${institutionId}`, {
        params: carePathwayId ? { carePathwayId } : undefined,
      })
      .then(({ data }) => data);
  },
  /** Site physicians for Next Patient on the TIME patient workspace (no care pathway id on this route). */
  getNextSitePhysicians: async (patientLinkageId: string, institutionId: string): Promise<Physician[]> => {
    return axios
      .get(`${TRIALS_NEST_API_ROOT}/v1/patients/${patientLinkageId}/institutions/${institutionId}/next/site-physicians`)
      .then(({ data }) => data);
  },
};
